import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MultipleStackPriceDirective } from './directives/multiple-stack-price/multiple-stack-price.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [MultipleStackPriceDirective],
  exports: [MultipleStackPriceDirective],
  providers: [MultipleStackPriceDirective],
})
export class CoreFeaturesMultipleStackPriceModule {}
